

.panel {
  //box-shadow: 0 3px 7px 5px rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: white;
  min-height: 340px;


  padding: 30px;
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius);
  transition: 0.25s;
  max-width: 100%;

  &:not(.fixed) {
    outline: 2px solid transparent;

    &:hover {
      outline-color: var(--beigedark);
    }
  }

}
